import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Brain } from 'lucide-react';

export const Navbar = () => {
  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-black/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 group" data-testid="logo-link">
            <div className="p-2 rounded-md bg-[#10B981] group-hover:scale-110 transition-transform">
              <Brain className="w-6 h-6 text-white" />
            </div>
            <span className="text-2xl font-black tracking-tight text-[#0A0A0A]">Xceltrain LLC</span>
          </Link>
          <div className="flex items-center gap-8">
            <a href="#expertise" className="text-sm font-medium text-[#52525B] hover:text-[#10B981] transition-colors" data-testid="nav-expertise">Expertise</a>
            <a href="#services" className="text-sm font-medium text-[#52525B] hover:text-[#10B981] transition-colors" data-testid="nav-services">Services</a>
            <a href="#about" className="text-sm font-medium text-[#52525B] hover:text-[#10B981] transition-colors" data-testid="nav-about">About</a>
            <a href="#contact" className="text-sm font-medium text-[#52525B] hover:text-[#10B981] transition-colors" data-testid="nav-contact">Contact</a>
          </div>
        </div>
      </div>
    </motion.nav>
  );
};